import Currency from '@/constants/currency';
export const getDefaultState = () => ({
  currency: Currency.CAD,
});
export const state = getDefaultState();
